const FIELD_NAME = 'email';

export default FIELD_NAME;
